import { render, staticRenderFns } from "./page-tool.vue?vue&type=template&id=40d212f1&"
import script from "./page-tool.vue?vue&type=script&lang=js&"
export * from "./page-tool.vue?vue&type=script&lang=js&"
import style0 from "./page-tool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports